import { NodeRequestConfig } from '../../../../ui/gzTree/uiElements/gzNodeRenameInput/helpers/types';
import { TreeNodeData } from '../../types';
import { TreeNodeActionValidator } from '../types';
import { cloneDeep } from 'lodash';
import { treePrefixRenderer } from '../../helpers/tree.helper';

export abstract class BaseActionHandlers {
  public abstract validator: TreeNodeActionValidator;
  protected abstract _createNodeRequest(nodeRequest: NodeRequestConfig): Promise<TreeNodeData>;

  public async createNodeRequest(nodeRequest: NodeRequestConfig): Promise<TreeNodeData> {
    // We clone nodeRequest because we need a copy with original data in GzNodeRenameInputWebComponent.createFinalNode
    const newNodeRequest = cloneDeep(nodeRequest);
    newNodeRequest.nodeData = await this._createNodeRequest(newNodeRequest);

    newNodeRequest.nodeData.temporaryNode = undefined;
    (newNodeRequest.nodeData as TreeNodeData).temporaryState = undefined;
    // If the node is newly created, it doesn't have this prop set from initial render
    if (!newNodeRequest.nodeData.namePrefixRenderer) {
      newNodeRequest.nodeData.namePrefixRenderer = () => treePrefixRenderer(newNodeRequest.nodeData.originalData);
    }

    return newNodeRequest.nodeData;
  }
}
